import { FormLabel } from "@mui/material";
import { UploadFileComponent } from "../../../../../components/core/UploadFile";
import { UploadFormElement } from "../../../types";
import FormElementTaskDescription from "../FormElementTaskDescription";
import type { JSX } from "react";

export const UploadInlineDisplay = ({
  element,
}: {
  element: UploadFormElement;
}) => {
  return (
    <>
      <FormLabel required={element.required}>{element.label}</FormLabel>
      <FormElementTaskDescription>
        {element.description}
      </FormElementTaskDescription>
      <UploadFileComponent
        files={[]}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderer={function (): JSX.Element | undefined {
          throw new Error("Function not implemented.");
        }}
        disabled={true}
      />
    </>
  );
};
